<script lang="ts" setup>
import { historyCommonConfig as config, historyDeleteModalTheme } from './configs/common'
import HistoryPageDefault from './components/HistoryPage.default.vue'
import HistoryPageFlipnovel from './components/HistoryPage.flipnovel.vue'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

const HistoryPage = loadBrandComponent({
  rocnovel: HistoryPageDefault,
  oceread: HistoryPageDefault,
  talewave: HistoryPageDefault,
  ficmoon: HistoryPageDefault,
  novelarc: HistoryPageDefault,
  storyella: HistoryPageDefault,
  silktale: HistoryPageDefault,
  pearla: HistoryPageDefault,
  fictora: HistoryPageDefault,
  marinovel: HistoryPageDefault,
  flipnovel: HistoryPageFlipnovel,
  moonpage: HistoryPageFlipnovel,
  storlyn: HistoryPageFlipnovel,
  novaris: HistoryPageFlipnovel,
})
</script>

<template>
  <HistoryPage :config="config" :delete-modal-theme="historyDeleteModalTheme" />
</template>
